<div class="content content-fixed">
  <div>
    <div class="container">
      <div class="items-center justify-between w-full mb-3 page-title-box d-sm-flex">
        <h2 class="flex w-40 gap-2 mb-0 text-xl">Patrons List</h2>
        <div class="flex justify-end gap-2 mb-3 flex-column">
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (ngModelChange)="filterCandidates()"
            placeholder="Search by ID, name, or email"
            class="w-96 h-10 border-2 border-gray-200 pl-2 mr-5.5"
            style="width: 400px"
          />
        </div>
      </div>

      <!-- Display error message if any -->
      <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <!-- Display the list of candidates if available -->
      <div>
        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th *ngFor="let header of headers" (click)="header.sortable && false && changeSort(header.field)">
                  {{ header.label }}
                  <span *ngIf="sortField === header.field">{{ sortDirection === 1 ? '↑' : '↓' }}</span>
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of tableBodyData; trackBy: trackByFn">
                <td *ngFor="let header of headers">
                  <ng-container *ngIf="header.field.indexOf('_status') === -1">
                    {{ row[header.field] }}
                  </ng-container>
                  <ng-container *ngIf="header.field.indexOf('_status') !== -1">
                    <div *ngIf="row[header.field]" class="api-result">
                      <span>{{ row[header.field].created_at }}</span>
                      <br/>
                      <span
                        [ngClass]="{
                          'badge-success': row[header.field].assessment_decision !== 'Hit',
                          'badge-danger': row[header.field].assessment_decision === 'Hit'
                        }"
                        class="w-full p-1 d-block"
                        >{{ row[header.field].assessment_decision }}</span>
                    </div>
                    <div *ngIf="!row[header.field]" class="api-result">
                      N/A
                    </div>
                  </ng-container>
                </td>
                <td>
                  <a [routerLink]="['/home/patrons', row.candidate_id, 'graph']">
                    <button
                        class="btn btn-sm btn-uppercase btn-default justify-center flex items-center confirm w-24"
                        [disabled]="isLoading"
                      >
                        <i class="fas fa-folder-open text-base iconbg"></i>
                        <i class="fas fa-search -ml-2 -mb-1 dual-color-icon text-xl"></i>
                    </button>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="noDataFound || tableBodyData.length === 0" style="color: rgb(6, 6, 6); text-align: center">No data found.</div>
        </div>
        <ng-template>
          <div *ngIf="error; else loading">
            <p>{{ error }}</p>
          </div>
        </ng-template>

        <ng-template #loading>
          <p>Loading...</p>
        </ng-template>

        <app-spinner *ngIf="isLoading" class="loading-overlay"></app-spinner>
      </div>

      <div class="container mt-auto pagination">
        <div class="pagination-controls">
          <button
            class="flex items-center justify-center btn btn-sm bt-3 btn-uppercase btn-default"
            (click)="goToFirstPage()"
            [disabled]="currentPage === 1"
          >
            <i class="fa fa-fast-backward" aria-hidden="true"></i>
          </button>

          <button
            class="flex items-center justify-center btn btn-sm bt-3 btn-uppercase btn-default"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
          >
            <i class="fa fa-step-backward" aria-hidden="true"></i>
          </button>

          <span class="mt-2 bt-3">Page {{ currentPage }} of {{ totalPages }}</span>

          <button
            class="flex items-center justify-center btn btn-sm bt-3 btn-uppercase btn-default"
            (click)="nextPage()"
            [disabled]="currentPage >= totalPages"
          >
            <i class="fa fa-step-forward" aria-hidden="true"></i>
          </button>

          <button
            class="flex items-center justify-center btn btn-sm bt-3 btn-uppercase btn-default"
            (click)="goToLastPage()"
            [disabled]="currentPage === totalPages"
          >
            <i class="fa fa-fast-forward" aria-hidden="true"></i>
          </button>
        </div>
      </div>

    </div>
  </div>
  <app-status-messages [tosterMessage]="tosterMessage"></app-status-messages>
</div>
